import { atom } from 'jotai';
export const $FallbackGpToApk = atom({ enable: false, apkLink: '' });
$FallbackGpToApk.debugLabel = '$FallbackGpToApk';
